module.exports = __webpack_public_path__ + "img/workedfor.8a6bab63.svg";